import _ from 'lodash';
import moment from 'moment';

import { setError } from '../App/ErrorsActions';

import customFieldsUtils from '../../util/customFieldsUtils';
import CalculationsWorker from '../../services/worker';

export const ERROR = 'DDP_ERROR';
export const LOADING = 'DDP_LOADING';
export const SUCCESS = 'DDP_SUCCESS';
export const SUCCESS_ONTIME = 'DDP_SUCCESS_ONTIME';

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool
  };
}

function success(data) {
  return {
    type: SUCCESS,
    data
  };
}

function successOnTime(data) {
  return {
    type: SUCCESS_ONTIME,
    data
  };
}

/** @function
 * @name getDoneStatuses
 * @desc Gets value of the filter for the doneStatuses setting
 * @param {Array} doneLists - mapped done lists
 * @param {Array} dones - selected done statuses IDs
 * @return {Array|undefined}
 */
function getDoneStatuses(doneLists, dones = []) {
  if (doneLists.length > 1) {
    return dones.length ? dones.map(i => i.value._id) : doneLists;
  }
}

export function getData() {
  return async (dispatch, getState) => {
    dispatch(isLoading(true));

    const { user } = getState().auth;
    const { selected } = getState().dashboards;
    const { data } = getState().app;
    const { app } = data;

    const allFilters = getState().filters;
    const {
      chart,
      allCustomFields,
      excludeWeekends,
      workStart,
      workEnd,
      holidays,
      enabledColors,
      dates,
      ddp
    } = allFilters;
    const filters = chart === 'overview' ? allFilters.overview : ddp;

    const customFields = customFieldsUtils.getSelected(allCustomFields, filters);

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, enabledColors, {
      isCsv: selected.isCsv,
      enableDoneFilters: user.config.enableDoneFilters,
      enableMissingDoneActivitiesInserting: user.config.enableMissingDoneActivitiesInserting
    });
    try {
      const doneStatuses = getDoneStatuses(selected.done, filters.selectedDones);
      const data = await worker.DueDatePerformance({
        lists: _.map([...selected.wip, ...selected.done], l => {
          return { _id: l };
        }),
        labels: filters.selectedLabels,
        members: filters.selectedMembers,
        customFields,
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        timeUnit: ddp.timeUnit,
        color: true,
        excludeWeekendOpts: {
          type: excludeWeekends,
          workStart,
          workEnd,
          holidays
        },
        doneStatuses: doneStatuses,
        dueDateTasks: filters.dueDateTasks,
        blockedTime: filters.blockedTime,
        blockers: filters.blockers
      });
      dispatch(success(data));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}

export function getOnTimeData() {
  return async (dispatch, getState) => {
    const { user } = getState().auth;
    const { selected } = getState().dashboards;
    const { data } = getState().app;

    const allFilters = getState().filters;
    const {
      chart,
      allCustomFields,
      excludeWeekends,
      workStart,
      workEnd,
      holidays,
      enabledColors,
      dates,
      ddp
    } = allFilters;
    const filters = chart === 'overview' ? allFilters.overview : ddp;

    const customFields = customFieldsUtils.getSelected(allCustomFields, filters);

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, enabledColors, {
      isCsv: selected.isCsv,
      enableDoneFilters: user.config.enableDoneFilters,
      enableMissingDoneActivitiesInserting: user.config.enableMissingDoneActivitiesInserting
    });
    try {
      const doneStatuses = getDoneStatuses(selected.done, filters.selectedDones);
      const ddpData = await worker.DueDatePerformance({
        lists: _.map([...selected.wip, ...selected.done], l => {
          return { _id: l };
        }),
        labels: filters.selectedLabels,
        members: filters.selectedMembers,
        customFields,
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        timeUnit: 'day',
        color: true,
        excludeWeekendOpts: {
          type: excludeWeekends,
          workStart,
          workEnd,
          holidays
        },
        doneStatuses: doneStatuses
      });

      const results = _(ddpData.series)
        .flatMap(i => {
          return i.data;
        })
        .sortBy('date')
        .groupBy(i => moment(i.date).startOf('month'))
        .map((i, date) => {
          const ontime =
            _.countBy(i, p => {
              return p.estimatedMinutes >= p.cycleTimeInMinutes;
            })['true'] || 0;

          return {
            x: +moment.utc(new Date(date)).local(),
            y: Math.round((ontime / i.length) * 10000) / 100
          };
        })
        .value();

      dispatch(successOnTime(results));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}
